import React, { forwardRef } from "react";

const Pagination = React.memo(
  forwardRef((props,ref) => {
    const {
      itemsPerPage,
      setItemsPerPage,
      pageNumber,
      setPageNumber,
      data,
      pageSizeArray,
    } = props;
    // console.log(props);
    const totalPage = Math.ceil(data?.content.length / itemsPerPage);
    let pageList = [];
    for (let i = 1; i <= totalPage; i++) {
      pageList.push(
        <li key={i}>
          <button
            className="dropdown-item"
            value={i}
            onClick={() => {
              if(ref.current){
                ref.current.scrollIntoView({behavior: "smooth", block: "start"});
              }
              setPageNumber(i - 1)
            }}
          >
            {i}
          </button>
        </li>
      ); // Page number 0 corresponds to 1st page on UI
    }
    return (
      <>
        <div className="d-flex gap-3 align-items-center" id="pageNumber">
          <div className="d-flex gap-2 align-items-center">
            <div className="dropdown selectPages mx-0" id="pageItems">
              <button
                className="btn btn-light dropdown-toggle border rounded small"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  paddingRight: "2rem", // Ensure space for the dropdown icon
                  textAlign: "left", // Align text properly
                }}
              >
                Page {pageNumber + 1} of {totalPage}{" "}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                {pageList}
              </ul>
            </div>
            <div className="dropdown selectPages mx-0" id="pageItems">
              <button
                className="btn btn-light dropdown-toggle border rounded small"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  paddingRight: "2rem", // Ensure space for the dropdown icon
                  textAlign: "left", // Align text properly
                }}
              >
                {itemsPerPage} Items per Page{" "}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                {pageSizeArray.map((size, index) => (
                  <li key={index}>
                    <button
                      className="dropdown-item"
                      value={size}
                      onClick={() => {
                        setPageNumber(0);
                        setItemsPerPage(size);
                      }}
                    >
                      {size}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="customPagination" style={{ fontSize: "12px" }}>
            Showing {pageNumber * itemsPerPage + 1} -{" "}
            {(pageNumber + 1) * itemsPerPage < data?.content.length
              ? (pageNumber + 1) * itemsPerPage
              : data?.content.length}{" "}
            of {data?.content.length} results.
          </div>
        </div>
      </>
    );
  })
);

export default Pagination;
